import { configureRuntimeApplicationForApp, getRuntimeInstallerBindingContext, getRuntimeInstallerGlobal, installRuntimePickersToApp, refreshRuntimeInstallerContributions } from "@visactor/vrender-core/entries/runtime-installer";

import { application } from "@visactor/vrender-core/application";

import { EnvContribution } from "@visactor/vrender-core/constants";

import { PickItemInterceptor, PickerService, PickServiceInterceptor } from "@visactor/vrender-core/picker/constants";

import { DrawContribution } from "@visactor/vrender-core/render/symbol";

import { bindBrowserCanvasModules } from "../canvas/contributions/browser/modules";

import { createContributionProvider, resolveContainerBinding } from "../common/explicit-binding";

import { BrowserEnvContribution } from "../env/contributions/browser-contribution";

import { bindArc3dCanvasPickerContribution } from "../picker/contributions/canvas-picker/arc3d-module";

import { bindArcCanvasPickerContribution } from "../picker/contributions/canvas-picker/arc-module";

import { bindAreaCanvasPickerContribution } from "../picker/contributions/canvas-picker/area-module";

import { bindCircleCanvasPickerContribution } from "../picker/contributions/canvas-picker/circle-module";

import { bindGlyphCanvasPickerContribution } from "../picker/contributions/canvas-picker/glyph-module";

import { bindImageCanvasPickerContribution } from "../picker/contributions/canvas-picker/image-module";

import { bindLineCanvasPickerContribution } from "../picker/contributions/canvas-picker/line-module";

import { bindPathCanvasPickerContribution } from "../picker/contributions/canvas-picker/path-module";

import { bindPolygonCanvasPickerContribution } from "../picker/contributions/canvas-picker/polygon-module";

import { bindPyramid3dCanvasPickerContribution } from "../picker/contributions/canvas-picker/pyramid3d-module";

import { bindRect3dCanvasPickerContribution } from "../picker/contributions/canvas-picker/rect3d-module";

import { bindRectCanvasPickerContribution } from "../picker/contributions/canvas-picker/rect-module";

import { bindRichtextCanvasPickerContribution } from "../picker/contributions/canvas-picker/richtext-module";

import { bindStarCanvasPickerContribution } from "../picker/contributions/canvas-picker/star-module";

import { bindSymbolCanvasPickerContribution } from "../picker/contributions/canvas-picker/symbol-module";

import { bindTextCanvasPickerContribution } from "../picker/contributions/canvas-picker/text-module";

import { CanvasPickerContribution } from "../picker/contributions/constants";

import { DefaultCanvasPickerService } from "../picker/canvas-picker-service";

import { bindBrowserWindowContribution } from "../window/contributions/browser-contribution";

const browserPickerInstallers = [ bindArcCanvasPickerContribution, bindArc3dCanvasPickerContribution, bindAreaCanvasPickerContribution, bindCircleCanvasPickerContribution, bindGlyphCanvasPickerContribution, bindImageCanvasPickerContribution, bindLineCanvasPickerContribution, bindPathCanvasPickerContribution, bindPolygonCanvasPickerContribution, bindPyramid3dCanvasPickerContribution, bindRectCanvasPickerContribution, bindRect3dCanvasPickerContribution, bindRichtextCanvasPickerContribution, bindStarCanvasPickerContribution, bindSymbolCanvasPickerContribution, bindTextCanvasPickerContribution ];

function createRegistryContributionProvider(entries) {
    return {
        getContributions: entries
    };
}

function bindBrowserEnv(container) {
    var _a, _b;
    (null === (_b = (_a = container).isBound) || void 0 === _b ? void 0 : _b.call(_a, BrowserEnvContribution)) || (container.bind(BrowserEnvContribution).toSelf().inSingletonScope(), 
    container.bind(EnvContribution).toService(BrowserEnvContribution));
}

function bindBrowserCanvasPicker(container) {
    container.isBound(DefaultCanvasPickerService) || container.bind(DefaultCanvasPickerService).toDynamicValue((() => new DefaultCanvasPickerService(createContributionProvider(CanvasPickerContribution, container), resolveContainerBinding(container, DrawContribution), createContributionProvider(PickItemInterceptor, container), createContributionProvider(PickServiceInterceptor, container)))).inSingletonScope(), 
    container.isBound(PickerService) ? container.rebind(PickerService).toService(DefaultCanvasPickerService) : container.bind(PickerService).toService(DefaultCanvasPickerService);
}

function createForcedEnvParams(envParams) {
    if (null != envParams && ("object" == typeof envParams || "function" == typeof envParams)) {
        const forcedEnvParams = Object.create(envParams);
        return forcedEnvParams.force = !0, forcedEnvParams;
    }
    return {
        force: !0
    };
}

function activateBrowserRuntimeEnv(envParams) {
    getRuntimeInstallerGlobal().setEnv("browser", createForcedEnvParams(envParams));
}

function installBrowserRuntimeEnvToApp(app, {bindEnv: bindEnv, bindCanvasModules: bindCanvasModules, bindWindowContribution: bindWindowContribution}, envParams) {
    configureRuntimeApplicationForApp(app);
    const bindingContext = getRuntimeInstallerBindingContext();
    bindEnv(bindingContext), bindCanvasModules(bindingContext), bindWindowContribution(bindingContext), 
    refreshRuntimeInstallerContributions(), activateBrowserRuntimeEnv(envParams);
}

function configureBrowserPickerFactory(app) {
    const bindingContext = getRuntimeInstallerBindingContext(), pickerContributions = createRegistryContributionProvider((() => app.registry.picker.getAll())), pickItemInterceptors = createRegistryContributionProvider((() => bindingContext.isBound(PickItemInterceptor) ? bindingContext.getAll(PickItemInterceptor) : [])), pickServiceInterceptors = createRegistryContributionProvider((() => bindingContext.isBound(PickServiceInterceptor) ? bindingContext.getAll(PickServiceInterceptor) : [])), global = getRuntimeInstallerGlobal();
    application.pickerServiceFactory = () => new DefaultCanvasPickerService(pickerContributions, {}, pickItemInterceptors, pickServiceInterceptors), 
    application.global = global;
}

export function installBrowserEnvToApp(app, envParams) {
    installBrowserRuntimeEnvToApp(app, {
        bindEnv: bindBrowserEnv,
        bindCanvasModules: bindBrowserCanvasModules,
        bindWindowContribution: bindBrowserWindowContribution
    }, envParams);
}

export function installBrowserPickersToApp(app) {
    configureRuntimeApplicationForApp(app);
    const bindingContext = getRuntimeInstallerBindingContext();
    browserPickerInstallers.forEach((bindPicker => bindPicker(bindingContext))), bindBrowserCanvasPicker(bindingContext), 
    installRuntimePickersToApp(app, CanvasPickerContribution), configureBrowserPickerFactory(app);
}
//# sourceMappingURL=browser.js.map